import { FoundationPrograms } from "../schoolPrograms/foundationProgram/foundationPrograms";
import { Inistitution } from "./institution";


export const SchoolFoundationProgram = () => {

    return (<>
        <Inistitution>
            <FoundationPrograms isAddFilesVisible={false} isDeleteFilesVisible={false}></FoundationPrograms>

        </Inistitution>
    </>);
}